/**
 * @description
 * Экранирует HTML-символы в строке, преобразуя специальные символы в их HTML-сущности.
 *
 * @param {string} text - Текст, который необходимо экранировать.
 *
 * @returns {string} Строка с экранированными HTML-символами.
 */
export const escapeHtml = (text: string): string => {
    const div = document.createElement('div');
    div.textContent = text;

    return div.innerHTML;
};
